import React from "react";
import PropTypes from "prop-types";

import RSLabel from "reactstrap/lib/Label";
import { gatherClasses } from "../../lib/utils";

const Label = props => {
  const { optional, optionalToNewLine, muted, noMargin, dataTestId, ...attr } =
    props;
  return (
    <RSLabel
      data-testid={dataTestId}
      {...attr}
      className={gatherClasses(
        props,
        muted ? "oui-text-muted" : null,
        noMargin ? "oui-m-0" : null
      )}
    >
      {attr.text}{" "}
      {optional ? (
        <small
          className={gatherClasses(
            null,
            "oui-text-muted",
            optionalToNewLine ? "oui-d-block" : null
          )}
        >
          (optional)
        </small>
      ) : null}
    </RSLabel>
  );
};

Label.propTypes = {
  text: PropTypes.string.isRequired,
  for: PropTypes.string,
  optional: PropTypes.bool,
  muted: PropTypes.bool,
  noMargin: PropTypes.bool,
  optionalToNewLine: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

Label.defaultProps = {
  optional: false,
  optionalToNewLine: true,
  muted: false,
  noMargin: false,
  dataTestId: "orion-label"
};

Label.displayName = "OrionLabel";

export default Label;
